export default "__VITE_ASSET__DR9kQZNx__"